import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import styles from './AlertCard.module.css';

interface AlertCardProps {
  icon?: ReactNode;
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
  isVisible: boolean;
  onDismiss?: () => void;
}

export default function AlertCard({
  icon,
  title,
  description,
  buttonText,
  onButtonClick,
  isVisible,
  onDismiss,
}: AlertCardProps) {
  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={onDismiss}>
      <div
        className={styles.card}
        role="alert"
        aria-live="assertive"
        onClick={(e) => e.stopPropagation()}
      >
        {onDismiss && (
          <button type="button" className={styles.dismissBtn} onClick={onDismiss} aria-label="Cerrar">
            ✕
          </button>
        )}

        <div className={styles.header}>
          {icon && <span className={styles.icon}>{icon}</span>}
          <h3 className={styles.title}>{title}</h3>
        </div>

        <p className={styles.description}>{description}</p>

        <button type="button" className={styles.actionBtn} onClick={onButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>,
    document.body
  );
}
